import { DOCUMENT_MODE } from "../../../constants/document";
import DummyCommand from "../dummyCommand";
import AddDocTableComponentCommand from "./addDocTableComponentCommand";
import AddTemplateTableComponentCommand from "./addTemplateTableComponentCommand";

class AddTableFactory {
  static getCommand(mode, componentData) {
    if (mode === DOCUMENT_MODE.DOCUMENT) {
      return new AddDocTableComponentCommand(componentData, mode);
    }
    if (mode === DOCUMENT_MODE.TEMPLATE) {
      return new AddTemplateTableComponentCommand(componentData, mode);
    }
    return new DummyCommand();
  }
}

export default AddTableFactory;
